export default {
  INTEGRATION_RELAX: true,
  INTEGRATION_EVERYMATRIX: true,
  INTEGRATION_THREE_PI: true,
  INTEGRATION_GAE_BRIDGE: true
}